/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MelcoModelsCustomWarning,
    MelcoModelsCustomWarningFromJSON,
    MelcoModelsCustomWarningFromJSONTyped,
    MelcoModelsCustomWarningToJSON,
    MelcoModelsReferralListItem,
    MelcoModelsReferralListItemFromJSON,
    MelcoModelsReferralListItemFromJSONTyped,
    MelcoModelsReferralListItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface MelcoModelsGenericList1MelcoModelsReferralListItem
 */
export interface MelcoModelsGenericList1MelcoModelsReferralListItem {
    /**
     * 
     * @type {Array<MelcoModelsReferralListItem>}
     * @memberof MelcoModelsGenericList1MelcoModelsReferralListItem
     */
    list: Array<MelcoModelsReferralListItem>;
    /**
     * 
     * @type {Array<MelcoModelsCustomWarning>}
     * @memberof MelcoModelsGenericList1MelcoModelsReferralListItem
     */
    warning_list?: Array<MelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof MelcoModelsGenericList1MelcoModelsReferralListItem
     */
    total: number;
}

export function MelcoModelsGenericList1MelcoModelsReferralListItemFromJSON(json: any): MelcoModelsGenericList1MelcoModelsReferralListItem {
    return MelcoModelsGenericList1MelcoModelsReferralListItemFromJSONTyped(json, false);
}

export function MelcoModelsGenericList1MelcoModelsReferralListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsGenericList1MelcoModelsReferralListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(MelcoModelsReferralListItemFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(MelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function MelcoModelsGenericList1MelcoModelsReferralListItemToJSON(value?: MelcoModelsGenericList1MelcoModelsReferralListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(MelcoModelsReferralListItemToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(MelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


